import SideBarBg from "./../../../../assets/SideBarBg2.png";
interface IProps {
	title: string;
	icon: string;
	value: string;
	setValue: (value: string) => void;
	type: string;
}

const Input = (props: IProps) => {
	return (
		<div className="relative flex w-full flex-col sm:w-4/5  md:w-full ">
			<label
				className="absolute -top-4 left-2 z-10  bg-white px-1 font-medium text-secondary "
				style={{
					backgroundImage: `url(${SideBarBg})`,
				}}
			>
				{props.title}
			</label>
			<input
				value={props.value}
				onChange={(e) => props.setValue(e.target.value)}
				type={props.type}
				className="  z-0 w-full rounded-lg border border-secondary bg-transparent p-2 outline-none"
			/>
		</div>
	);
};

export default Input;
